import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function CreateNapUredaj(
    clientUuid, 
    tid,
    label,
    description,
    isuNumber,
    businessPremisesUuid,
    ecommerce
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client/device?clientUuid=' + clientUuid, {
            method: 'post',
            headers: { 
                'Authorization' : unHashedJwt.data                 
            },
            data: {
                "tid": tid.trim(),
                "label": label.trim(),
                "description": description.trim(),
                "isuNumber": ecommerce ? undefined : isuNumber.trim(),
                "businessPremisesUuid": businessPremisesUuid.trim(),
                "ecommerce": ecommerce
            }      
        }).then(res => res)
        .catch(error => error.response.data),
        "Admin"
        );
}